<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-map-marker-path"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('linehaul_map') }}
        </div>
      </template>
      <v-row>
        <v-col cols="8">
          <GmapMap
            ref="map"
            style="width: 100%; height: 600px;"
            :zoom="1"
            :center="{lat: 0, lng: 0}"
            :options="mapOptions"
          >
            <GmapCluster :minimum-cluster-size="4">
              <GmapMarker
                v-for="(m, index) in markers"
                :key="index"
                :ref="`marker${index}`"
                :position="m.position"
                :clickable="true"
                :label="m.name || m.title"
                :icon="{
                  url: require('../../../assets/location_dot.png'),
                  scaledSize: new google.maps.Size(15, 15), // scaled size
                  origin: new google.maps.Point(0, 0), // origin
                  anchor: new google.maps.Point(0, 0), // anchor

                }"
              >
                {{ m.title }}
              </GmapMarker>
            </GmapCluster>
          </GmapMap>
          <v-row
            justify="end"
            class="mt-3"
          >
            <v-btn
              color="primary"
              @click="save"
            >
              {{ $t('save') }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col>
          <v-list>
            <v-list-item
              v-for="(element, index) in items"
              :key="element.id"
              class="d-flex flex-column"
            >
              <v-col>
                <v-row>
                  {{ element.name|| element.title }}
                </v-row>
                <v-row class="mt-2">
                  <v-col>
                    <v-row
                      no-gutters
                      justify="center"
                    >
                      <v-btn
                        class="mr-0"
                        fab
                        x-small
                        :color="element.visible ? 'primary' : 'secondary'"
                        @click="() => {
                          element.visible = !element.visible;

                          if(element.visible)generateRoute(element, index)
                          else hideRoute(element, index)
                        }"
                      >
                        <v-icon>
                          {{ element.visible ? 'visibility' : 'visibility_off' }}
                        </v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="2">
                    <v-menu
                      :ref="`color_menu-${index}`"
                      v-model="colorMenu[index]"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      max-width="230px"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :color="element.color"
                          small
                          dense
                          v-on="on"
                        />
                      </template>

                      <v-color-picker
                        mode="hexa"
                        :value="element.color"
                        show-swatches
                        @update:color="val => setColor(val, element, index)"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      v-model="element.width"
                      :items="[1,2,3,4,5,6,7,8,9,10]"
                      dense
                      :label="$t('width')"
                      @change="generateRoute(element, index)"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-row>
                      <v-switch
                        v-model="element.dashed"
                        :label="$t('dashed')"
                        class="mt-0 ml-5"
                        @change="generateRoute(element, index)"
                      />
                    </v-row>
                  </v-col>
                </v-row>
                <v-divider />
              </v-col>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>
<script>
  import Auth from '@/mixins/Auth'
  import { SUPERUSER } from '../../../utils/constants'
  import { gmapApi } from 'vue2-google-maps'

  export default {
    mixins: [Auth],
    data: function () {
      return {
        endpoint: 'linehaul-routes',
        name: this.$t('linehaul_map'),
        crudl: {
          C: SUPERUSER.val,
          R: SUPERUSER.val,
          U: SUPERUSER.val,
          D: SUPERUSER.val,
          L: SUPERUSER.val,
        },
        colorMenu: {},
        directions: {},
        items: [],
        markers: [],
        mapOptions: {
          disableDefaultUI: true,
          styles: [
            {
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f5f5f5',
                },
              ],
            },
            {
              elementType: 'labels.icon',
              stylers: [
                {
                  visibility: 'on',
                },
              ],
            },
            {
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#616161',
                },
              ],
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  color: '#f5f5f5',
                },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'administrative.land_parcel',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#bdbdbd',
                },
              ],
            },
            {
              featureType: 'poi',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#ffffff',
                },
              ],
            },
            {
              featureType: 'road',
              elementType: 'labels.icon',
              stylers: [
                {
                  visibility: 'on',
                },
              ],
            },
            {
              featureType: 'road.arterial',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#757575',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dadada',
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#616161',
                },
              ],
            },
            {
              featureType: 'road.local',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
            {
              featureType: 'transit',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e5e5e5',
                },
              ],
            },
            {
              featureType: 'transit.station',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#eeeeee',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#c9c9c9',
                },
              ],
            },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [
                {
                  color: '#9e9e9e',
                },
              ],
            },
          ],
        },
      }
    },
    computed: {
      uniqueWaypoints: function () {
        const waypoints = []
        this.$_.each(this.items, r => {
          if (!r.visible) { return }
          this.$_.each(r.waypoints, rwp => {
            const exists = this.$_.findIndex(waypoints, wp => { return wp.latitude === rwp.latitude && wp.longitude === rwp.longitude })
            if (exists > -1) { return }
            waypoints.push(rwp)
          })
        })

        return waypoints
      },
      google: gmapApi,
      trimmedRoutes: function () {
        return this.$_.map(this.items, r => {
          const { id, visible, color, dashed } = r
          return { id, visible, color, dashed }
        })
      },
    },
    watch: {
      items: function () {
        this.$gmapApiPromiseLazy().then(() => {
          if (this.items.length) {
            this.$_.each(this.items, (r, i) => { if (r.waypoints && r.waypoints.length) this.requestRouteInfo(r, i) })
          }
          this.generate()
        })
      },
      uniqueWaypoints: function () {
        this.markers = []
        this.$gmapApiPromiseLazy().then(() => {
          this.$_.each(this.uniqueWaypoints, wp => {
            this.markers.push(new google.maps.Marker({
              position: { lat: wp.latitude, lng: wp.longitude },
              title: wp.name || wp.address_string,
            }))
          })
        })
      },
    },
    created: function () {
      this.getDataFromApi()
    },
    methods: {
      getDataFromApi () {
        if (!this.canList()) { return }
        this.loading = true

        this.$get('/' + this.endpoint, { paginate: 0 }, true)
          .then(response => {
            this.items = response.data
            this.loading = false
          })
          .catch(e => {
            this.loading = false
          })
      },
      trimWaypoints: function (waypoints) {
        const wps = [...waypoints]
        wps.shift()
        wps.pop()

        return this.$_.map(wps, wp => ({
          location: { lat: wp.latitude, lng: wp.longitude },
          stopover: true,
        }))
      },
      generate: function () {
        this.$_.each(this.items, (r, i) => {
          setTimeout(() => this.generateRoute(r, i), 2000)
        })
      },
      requestRouteInfo: function (r, i) {
        const directionsService = new google.maps.DirectionsService()
        const request = {
          origin: { lat: r.waypoints[0].latitude, lng: r.waypoints[0].longitude },
          waypoints: this.trimWaypoints(r.waypoints),
          destination: { lat: r.waypoints[r.waypoints.length - 1].latitude, lng: r.waypoints[r.waypoints.length - 1].longitude },
          travelMode: 'DRIVING',
        }

        directionsService.route(request, (response, status) => {
          if (status === 'OK') {
            this.directions[i] = { ...this.directions[i], direction: response }
          } else {
            window.alert('Directions request failed due to ' + status)
          }
        })
      },
      generateRoute: function (r, i) {
        if (!r.visible) { return }

        if (this.directions[i]) {
          if (this.directions[i].renderer) { this.directions[i].renderer.setMap(null) }
          const lineSymbol = {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            strokeColor: r.color,
            strokeWeight: r.width,
            scale: 4,
          }
          this.directions[i].renderer = new google.maps.DirectionsRenderer(
            {
              suppressMarkers: true,
              polylineOptions: {
                strokeOpacity: 0,
                icons: [{
                  icon: lineSymbol,
                  offset: '0',
                  repeat: r.dashed ? '20px' : '4px',
                }],

              },

            },
          )

          this.$nextTick(() => {
            this.$refs.map.$mapPromise.then(map => {
              this.directions[i].renderer.setMap(map)
            })
          })

          this.directions[i].renderer.setDirections(this.directions[i].direction)
        }
      },
      hideRoute: function (r, i) {
        if (this.directions[i]) {
          this.directions[i].renderer.setMap(null)

          this.directions[i].renderer = null
        }
      },
      setColor: function (c, r, i) {
        this.items[i].color = c.hex
        const route = { ...r, color: c.hex }
        this.generateRoute(route, i)
      },
      save: function () {
        if (!this.canCreate()) { return }
        if (!this.canUpdate()) { return }

        this.loading = true

        this.$put(`/${this.endpoint}/map`, this.trimmedRoutes)
          .then(response => {
            this.$toast(`${this.$t(this.name)} ${this.$t('saved_correctly')}`)

            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
    },
  }
</script>
